import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getPresenceFor /*, isScannedYet*/ } from "../modules/utils";
import "./Detail.scss";
import { idxdb } from "./Firestore";
import ButtonLink from "./ButtonLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle /*, faTimesCircle*/ } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";

const Detail = (props) => {
  const [curPresence, setCurPresence] = useState(null);
  const [html, setHtml] = useState(null);
  const allScans = useSelector((state) => state.db.scans);
  const globalHtml = useSelector((state) => state.db.html); // Le HTML dans la bdd d'appli de pointage
  const fields = useSelector((state) => state.db.fields);

  const setImages = async (html) => {
    const regexp = /<img2 +name="([^"]+)" *\/>/g;
    const all_tags = [...html.matchAll(regexp)];

    var res = html;
    for (const tag_parts of all_tags) {
      try {
        const image = await idxdb.images.get(tag_parts[1]);
        res = res.replaceAll(
          tag_parts[0],
          `<img src="data:${image.data.type};base64,${image.data.base64}" />`
        );
      } catch (err) {
        res = res.replaceAll(tag_parts[0], `<span>IMG ${tag_parts[1]} ???</span>`);
      }
    }

    return res;
  };

  useEffect(() => {
    const setFields = async (html) => {
      var res = html;

      for (const field of fields) {
        res = res.replaceAll(`%${field.name}%`, props.item[field.name]);
      }
      return res;
    };

    setCurPresence(getPresenceFor(props.item.qrcode));
    // Ne traiter le HTML que s'il existe dans l'item (l'invité) ou en template global (param dans db app pointage)
    // Le html personnalisé de l'invité a priorité sur le globalHtml
    if (props.item.html?.length > 0 && props.item.html.trim() !== "") {
      setImages(props.item.html)
        .then((html) => {
          return setFields(html);
        })
        .then((html) => {
          return setHtml(html);
        })
        .catch((err) => {
          setHtml(null);
        });
    } else if (globalHtml?.length > 0 && (globalHtml.trim() !== "" || globalHtml.trim() !== "n")) {
      // N'utiliser le globalHtml que s'il existe
      setImages(globalHtml)
        .then((html) => {
          return setFields(html);
        })
        .then((html) => {
          return setHtml(html);
        })
        .catch((err) => {
          setHtml(null);
        });
    } else {
      // Si aucun HTML n'est disponible, ne pas afficher de contenu
      setHtml(null);
    }
  }, [props.item, allScans, globalHtml, fields]);

  const doSwitchOn = () => {
    if (!props.noToggle) {
      props.onPresence(true);
    }
  };

  const doSwitchOff = () => {
    if (!props.noToggle) {
      props.onPresence(false);
    }
  };

  return (
    <div className="detail">
      <div>
        Invité scanné ?
        {curPresence && (
          <FontAwesomeIcon className="fa-toggle-on" icon={faCheckCircle} onClick={doSwitchOff} />
        )}
        {!curPresence && (
          <FontAwesomeIcon className="fa-toggle-unset" icon={faCircle} onClick={doSwitchOn} />
        )}
        <ButtonLink onClick={props.onCloseDetail}>Fermer</ButtonLink>
      </div>
      {/* N'afficher le contenu que si html existe */}
      {html && <div className="detail-content">{parse(html)}</div>}
    </div>
  );
};

export default Detail;
